import React, { createContext, FunctionComponent, useContext, useState } from 'react'
import { useApi } from '../providers/ApiProvider'
import { useHistory } from 'react-router-dom'

export type RootState = {
  username: string | null
}
export type RootFunctions = {}

const InitialState: RootState = {
  username: null,
}

const Context = createContext<
  [RootState, (state: any) => void]
>([InitialState, () => {
}])

export const ProfileProvider: FunctionComponent = ({ children }) => {
  const [state, setState] = useState<RootState>(InitialState)

  const api = useApi()
  const history = useHistory()

  React.useEffect(() => {
    api.getProfile()
      .then(data => {
        setState({
          username: data.username,
        })
      })
      .catch(() => {
        api.logout()
        history.push('/')
      })
  }, [api, history])

  return (
    <Context.Provider value={[state, setState]}>
      {children}
    </Context.Provider>
  )
}

export const useProfile = (): RootFunctions & RootState => {
  const [state] = useContext(Context)
  return {
    ...state,
  }
}
